<template>

  <div class="nav">
    <!-- <div class="logo">
      <img src="@/assets/homeImg/bigLogo.png" alt="">
      <img src="@/assets/homeImg/gwLOGO.png" alt="">
    </div> -->
    <div class="title" @click="$router.push('/')">
      <img src="@/assets/homeImg/gwLOGO.png" alt="" ref="logoRef" class="title_logo">
    </div>
    <div class="menu">
      <el-menu @select="handleHeadNavSelect" class="el-menu-demo" mode="horizontal" default-active="index"
               background-color="transparent"
      >
        <el-menu-item index="index" class="jumpHome">首页</el-menu-item>
        <SubMenuTree :objectData="categoryData.gywm"/>
        <SubMenuTree :objectData="categoryData.djgz"/>
        <SubMenuTree :objectData="categoryData.gxxm"/>
      </el-menu>
      <el-menu @select="handleHeadNavSelect" class="el-menu-demo" mode="horizontal" background-color="transparent">
        <SubMenuTree :objectData="categoryData.woyaojuankuan"/>
        <SubMenuTree :objectData="categoryData.wysq"/>
        <SubMenuTree :objectData="categoryData.zyzzm"/>
      </el-menu>
<!--      <span class="title2-span"><a :href="gwUrl" class="title2">教育公益信息网</a></span>-->
    </div>
    <div>
      <el-col :span="6" style="float:right;display: flex;justify-content: end;hight: 40px;">
        <el-input class="search"
          type="text"
          placeholder="请输入"
          v-model="searchText"
          @keyup.enter.native="searchBy"
          style="width: 220px; cursor: pointer;margin-right: 20px"
        >
          <el-button @click="searchBy" slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <el-button class="btn" plain @click="handleLogin">登录</el-button>
      </el-col>
    </div>
<!--    <i class="icon-search">
      &lt;!&ndash; <svg-icon slot="prefix" icon-class="search" class="el-input__icon input-icon" /> &ndash;&gt;
      <svg class="svgIcon" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <title>切片</title>
        <g id="二级页面" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="详情页-顶到广告" transform="translate(-1724.000000, -40.000000)">
            <g id="编组-33" transform="translate(64.000000, 36.000000)">
              <g id="搜索1" transform="translate(1660.000000, 4.000000)">
                <rect id="矩形" x="0" y="0" width="40" height="40"></rect>
                <g id="编组" transform="translate(8.333333, 8.333333)" fill-rule="nonzero" stroke="#fff"
                   stroke-width="2"
                >
                  <path
                    d="M11.6666667,0 C18.1099887,0 23.3333333,5.22334459 23.3333333,11.6666667 C23.3333333,18.1099887 18.1099887,23.3333333 11.6666667,23.3333333 C5.22334459,23.3333333 0,18.1099887 0,11.6666667 C0,5.22334459 5.22334459,0 11.6666667,0 Z"
                    id="路径"
                  ></path>
                  <line x1="20.9763107" y1="20.9763107" x2="24.5118446" y2="24.5118446" id="路径-11"
                        stroke-linecap="round" stroke-linejoin="round"
                  ></line>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </i>-->
  </div>
</template>

<script>
import categoryData from '@/utils/data.js'
import SubMenuTree from '@/components/SubMenuTree.vue'

export default {
  components: {
    SubMenuTree
  },
  mixins: [categoryData],
  name: 'HeadNav',
  data() {
    return {
      searchText:"",
      activeIndex: '1'
    }
  },
  methods: {
    searchBy(){
      window.location.href = `/search?q=${this.searchText}`
    },
    handleLogin() {
      window.open(process.env.VUE_APP_URL_JJh);
      // window.open("process.env.VUE_APP_URL_JJh", "_blank")
    },
    handleHeadNavSelect(key, keyPath) {
      if (key === 'index') {
        this.$router.push({ path: '/' })
      } else {
        let url = `/details/${keyPath[0]}/${key}`
        this.jumpInform(url)
      }

      console.log(key, keyPath)

    },
    jumpInform(url) {
      // /details/gywm/jjhgszq

      let routeUrl = this.$router.resolve({
        path: url
      })
      window.open(routeUrl.href, '_self')
    },
    jumpHome() {
      this.$router.push({
        path: '/'
      })
    }
  },
  mounted() {
    $('.parent').contents().unwrap()
    // setTimeout(()=>{
    //   debugger
    // },5000)
  }
}
</script>

<style lang="scss" scoped>


.el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
  color: #ffffff;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #f53f3f;
}

.el-submenu-back {
  margin-right: 0 !important;
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  margin-left: 2px;
}

.nav {
  width: 100%;
  color: #fff;
  height: 120px;
  position: relative;
  padding: 40px 36px 0 0;
  min-width: 1440Px;

  .menu {
    position: absolute;
    display: flex;
    left: 480px;
    top: 46px;

    .el-menu:nth-child(2) {
      margin-left: 80px;
    }
  }

  .logo {
    width: 64px;
    height: 64px;
    position: absolute;
    top: 28px;
    left: 36px;

    img {
      width: 64px;
      height: 64px;
    }
  }

  .title {
    position: absolute;
    top: 28px;
    left: 36px;
    font-size: 24px;
    cursor: pointer;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 1;
    // display: flex;
    // flex-wrap: wrap;
  }

  .title2 {
    margin-left: 80px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    line-height: 28px;
  }

  .title2-span {
    font-size: 0;
  }

  .title2:hover {
    color: #f53f3f;
  }

  .btn {
    float: right;
    padding: 12px 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    border: 1px solid #fff;
    border-radius: 8px;
    background-color: transparent;
    color: #fff;
  }
}

.el-menu-demo {
  border-bottom: solid 0px;
}

.child-menu > div.el-menu--horizontal {
  //left: 210px !important;
}

.el-menu--popup-right-start {
  margin: 0;
}

.el-submenu {
  margin-right: 16px;
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent;
  color: #f53f3f;
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover .el-icon-arrow-down {
  color: #f53f3f;
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 20px;
  color: #fff;
  line-height: 28px;
  padding: 0;
  height: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  border-bottom: 0 solid transparent;
  font-weight: 600;
}

.el-dropdown {
  position: absolute;
  top: 46px;
  left: 480px;
  color: #fff;
  font-size: 20px;
}

.icon-search {
  position: absolute;
  right: 156px;
  width: 40px;
  height: 40px;
}

::v-deep ul.el-menu .el-menu--popup {
  background-color: red !important;
  border-radius: 8px;
  min-width: 0px !important;
}

.el-menu-item {
  background-color: transparent !important;
  // opacity: 0.9;
  padding: 0px 8px;
  height: 49px !important;
}

.el-menu-item i {
  display: block;
  // width: 168px;
  // padding: 12px 0;
  color: #1d2129;
  text-align: center;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  opacity: 1 !important;
  line-height: 49px;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  line-height: 49px;
}

.el-menu-item:hover i {
  display: block;
  background: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.el-menu-item:active i {
  color: #f53f3f;
}

.child-menu {
  margin-right: 0;
  height: 49px;
}

.child-menu > ::v-deep div.el-submenu__title {
  height: 49px;
  line-height: 49px;
}

.el-submenu__title i {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
}

.child-menu > ::v-deep div.el-submenu__title:hover {
  background: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

::v-deep .el-submenu__title {
  background-color: #fff !important;
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 25px;
}

::v-deep .el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #1d2129 !important;
}

::v-deep .el-menu--popup-bottom-start {
  box-shadow: 0 -5px 0 #f53f3f !important;
}

::v-deep div.el-menu,
div.el-menu--popup,
div.el-menu--popup-bottom-start {
  box-shadow: 0 -5px 0 #f53f3f !important;
  border-radius: 8px;
}

// menu 样式大全
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  background-color: rgba(255, 255, 255, 0.6);
  float: none;
  color: #1d2129 !important;
  z-index: 100;
  font-weight: 500;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  // line-height: 25px;
  text-align: center;
}

::v-deep ul.el-menu .el-menu--popup {
  background-color: red !important;
  border-radius: 8px;
  min-width: 0px !important;
}

.el-menu-item {
  // background-color: #ffffffd5 !important;
  // opacity: 0.9;
  padding: 0px 8px;
  height: 49px;
}

.el-menu-item i {
  display: block;
  // width: 168px;
  // padding: 12px 0;
  color: #1d2129;
  text-align: center;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  opacity: 1 !important;
  line-height: 49px;
}

.el-menu-item:hover i {
  display: block;
  // width: 168px;
  // height: 49px;
  background: #fff;
  // opacity: 1 !important;
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // line-height: 49px;
}

::v-deep .el-submenu__title {
  background-color: transparent !important;
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 25px;
}

::v-deep .el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #1d2129 !important;
}

::v-deep .el-menu--popup-bottom-start {
  box-shadow: 0 -5px 0 #f53f3f !important;
}

::v-deep div.el-menu,
div.el-menu--popup,
div.el-menu--popup-bottom-start {
  box-shadow: 0 -5px 0 #f53f3f !important;
  border-radius: 8px;
}

// menu 样式大全
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  background-color: rgba(255, 255, 255, 0.6);
  float: none;
  color: #1d2129 !important;
  z-index: 100;
  font-weight: 500;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 25px;
  text-align: center;
}

.el-button.is-plain:hover {
  background-color: #fff !important;
  color: #f53f3f !important;
}

.nav .btn {
  span {
    width: 32px;
    height: 24px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 24px;
  }
}

li.el-menu-item.jumpHome {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 28px;
  border-bottom: 0;
  margin-right: 34px;
  user-select: none;
}

.el-menu-item[data-v-c6e7507a]:hover,
.el-menu-item[data-v-c6e7507a]:focus {
  color: #f53f3f !important;
}

.svgIcon {
  width: 40px;
  height: 40px;
}

.title_English {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 1;
  display: inline-block;
}

.title_Chinese {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 1;
  display: block;
}

.svg-icon {
  width: 32px;
  height: 32px;
  color: #fff;
}

.title_logo {
  width: 296px;
  height: 64px;
}
</style>

<style lang="scss" scoped>
@media screen and (max-width: 1440px) {
  .title_English {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 1;
    display: inline-block;
    transform-origin: 0 100%;
    transform: scale(0.7);
  }
}

.search ::v-deep .el-input__inner,
.search ::v-deep .el-input-group__append
{
  background: transparent!important;
  color: #FFFFFF!important;
}

.search ::v-deep .el-input-group__append {
  background: rgba(255,255,255,0.1) !important;
}

.search ::v-deep .el-input.is-active .el-input__inner,
.search ::v-deep .el-input__inner:focus {
  border-color: #f53f3f;
  outline: 0;
}

</style>
